<script>
  import relatorioServico from '../relatorio.servico';
  import pessoaServico from '~modulos/pessoa/servico';
  import cursoServico from '~modulos/curso/servico';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker, checkbox } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, checkbox, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          porAluno: false,
          porVencimento: false,
          porPagamento: false,
          porCurso: false,
          porTurma: false,
          porSituacao:false,
          idAluno: '',
          idCurso: '',
          idTurma: '',
          idSituacao:'',
          dataVencimentoInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataVencimentoFim: moment(new Date()).format('DD/MM/YYYY'),
          dataPagamentoInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataPagamentoFim: moment(new Date()).format('DD/MM/YYYY'),
        },
        relatorio: {},
        aluno: null,
        alunos: [],
        curso: null,
        cursos: [],
        turma: null,
        turmas: [],
        situacao: null,
        dataVencimentoInicio: '',
        dataVencimentoFim: '',
        dataPagamentoInicio: '',
        dataPagamentoFim: '',
        porAluno: false,
        porVencimento: false,
        porPagamento: false,
        porCurso: false,
        porTurma: false,
        porSituacao:false,
      }
    },
    methods: {
      listaDeAlunos() {
        return pessoaServico
          .alunos()
          .then(alunos => {
            this.alunos = alunos;
          });
      },
      listaDeCursos() {
        return cursoServico
          .cursos()
          .then(cursos => {
            this.cursos = cursos;
          });
      },
      listaDeTurmas() {
        return cursoServico
          .turmas(this.filtros.idCurso ? this.filtros.idCurso : 0)
          .then(turmas => {
            this.turmas = turmas;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarAluno();
        this.setarCurso();
        this.setarTurma();
        this.dataVencimentoInicio = this.filtros.dataVencimentoInicio;
        this.dataVencimentoFim = this.filtros.dataVencimentoFim;
        this.dataPagamentoInicio = this.filtros.dataPagamentoInicio;
        this.dataPagamentoFim = this.filtros.dataPagamentoFim;
        this.porAluno = this.filtros.porAluno;
        this.porVencimento = this.filtros.porVencimento;
        this.porPagamento = this.filtros.porPagamento;
        this.porCurso = this.filtros.porCurso;
        this.porTurma = this.filtros.porTurma;
        this.porSituacao = this.filtros.porSituacao;
        this.situacao = this.filtros.idSituacao;
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.mensalidadesAgrupadoPorAluno(this.filtros);
          })
          .then(resultado => { 
            let total = resultado.length;

            $('#gerar').button('reset');
            
            if (total === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              if (total > 7000) {
                this.$swal({
                  title: 'Informação do sistema',
                  html: 'Esta consulta retornou muitos registros, tente utilizar mais filtros.',
                  type: 'info',
                  confirmButtonText: 'Ok',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                });
              } else {
                this.relatorio = resultado.groupBy('ordem'); 

                this.$nextTick(() => {
                  $('html, body').animate({
                    scrollTop: $('#relatoriobody').offset().top
                  }, 800);
                });
              }
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      gerarExcel() {
        this.relatorio = {};
        this.setarAluno();
        this.setarCurso();
        this.setarTurma();
        this.dataVencimentoInicio = this.filtros.dataVencimentoInicio;
        this.dataVencimentoFim = this.filtros.dataVencimentoFim;
        this.dataPagamentoInicio = this.filtros.dataPagamentoInicio;
        this.dataPagamentoFim = this.filtros.dataPagamentoFim;
        this.porAluno = this.filtros.porAluno;
        this.porVencimento = this.filtros.porVencimento;
        this.porPagamento = this.filtros.porPagamento;
        this.porCurso = this.filtros.porCurso;
        this.porTurma = this.filtros.porTurma;
        this.porSituacao = this.filtros.porSituacao;
        this.situacao = this.filtros.idSituacao;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.mensalidadesAgrupadoPorAlunoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      habilitarDesabilitarAluno() {
        $('#aluno').prop('disabled', !this.filtros.porAluno);
        this.filtros.idAluno = '';
      },
      habilitarDesabilitarCurso() {
        $('#curso').prop('disabled', !this.filtros.porCurso);
        this.filtros.idCurso = '';

        this.$nextTick(() => {
          $('#curso').val('');
          $('#curso').trigger('change.select2');
        });

        this.listaDeTurmas();
      },
      habilitarDesabilitarTurma() {
        $('#turma').prop('disabled', !this.filtros.porTurma);
        this.filtros.idTurma = '';
      },
      habilitarDesabilitarSituacao() {
        $('#situacao').prop('disabled', !this.filtros.porSituacao);
        this.filtros.idSituacao = '';
      },
      totalValorParcelaPorAluno(aluno) {
        return aluno.reduce((total, parcela) => {
          return total + (parcela.valorReceberPagar + parcela.descontoMensalidade);
        }, 0);
      },
      totalBolsaPorAluno(aluno) {
        return aluno.reduce((total, parcela) => {
          return total + parcela.descontoMensalidade;
        }, 0);
      },
      totalValorReceberPorAluno(aluno) {
        let alunoFiltrado = aluno.filter((parcela) => {
            return (!parcela.cancelada) && (parcela.data === null) ;
        });

        return alunoFiltrado.reduce((total, parcela) => {
            return total + parcela.valorReceberPagar;
        }, 0);
      },
      totalAcrescimoPorAluno(aluno) {
        return aluno.reduce((total, parcela) => {
          return total + (parcela.juros + parcela.multa);
        }, 0);
      },
      totalDescontoPorAluno(aluno) {
        return aluno.reduce((total, parcela) => {
          return total + parcela.desconto;
        }, 0);
      },
      totalValorPagoPorAluno(aluno) {
        return aluno.reduce((total, parcela) => {
          return total + parcela.valorPago;
        }, 0);
      },
      setarAluno() {
        const idAluno = this.filtros.idAluno;

        this.aluno = idAluno ? this.alunos.find(a => a.id == idAluno) : null; 
      },
      setarCurso() {
        const idCurso = this.filtros.idCurso;

        this.curso = idCurso ? this.cursos.find(c => c.id == idCurso) : null; 
      },
      setarTurma() {
        const idTurma = this.filtros.idTurma;

        this.turma = idTurma ? this.turmas.find(t => t.id == idTurma) : null; 
      }
    },
    computed: {
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Mensalidades Agrupadas por Aluno`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';
      
      this.$events.on('botaoAcao', function() {
        window.print();
      });
      
      this.listaDeAlunos();
      this.listaDeCursos();
      this.listaDeTurmas();
      const _this = this; 

      $('#curso').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idCurso', this.value);
        
        _this.filtros.idTurma = '';
        _this.listaDeTurmas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    },
    watch: {
      'filtros.porAluno': 'habilitarDesabilitarAluno',
      'filtros.porCurso': 'habilitarDesabilitarCurso',
      'filtros.porTurma': 'habilitarDesabilitarTurma',
      'filtros.porSituacao': 'habilitarDesabilitarSituacao',
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('aluno')}">
                <checkbox v-model="filtros.porAluno" :true-value="true" type="success">Aluno</checkbox>

                <select disabled
                        id="aluno"
                        class="form-control"
                        v-model="filtros.idAluno"
                        data-vv-name="aluno"
                        v-validate="filtros.porAluno ? 'required' : ''">
                  <option value="">Selecione...</option>
                  <option :value="a.id" v-for="(a, index) in alunos">{{ a.nome }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('aluno')">{{ errors.first('aluno') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataVencimentoInicio')}">
                <checkbox v-model="filtros.porVencimento" :true-value="true" type="success">Período de vencimento</checkbox>

                <datepicker v-show="filtros.porVencimento"
                            id="dataVencimentoInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataVencimentoInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataVencimentoInicio')">{{ errors.first('dataVencimentoInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataVencimentoFim')}">
                <label class="open checkbox success">
                  <span class="icon dropdown-toggle"></span> &nbsp;
                </label>

                <datepicker v-show="filtros.porVencimento"
                            id="dataVencimentoFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataVencimentoFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataPagamentoInicio')}">
                <checkbox v-model="filtros.porPagamento" :true-value="true" type="success">Período de pagamento</checkbox>

                <datepicker v-show="filtros.porPagamento"
                            id="dataPagamentoInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataPagamentoInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataPagamentoInicio')">{{ errors.first('dataPagamentoInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataPagamentoFim')}">
                <label class="open checkbox success">
                  <span class="icon dropdown-toggle"></span> &nbsp;
                </label>

                <datepicker v-show="filtros.porPagamento"
                            id="dataPagamentoFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataPagamentoFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('curso')}">
                <checkbox v-model="filtros.porCurso" :true-value="true" type="success">Curso</checkbox>

                <select disabled
                        id="curso"
                        class="form-control"
                        v-model="filtros.idCurso"
                        data-vv-name="curso"
                        v-validate="filtros.porCurso ? 'required' : ''">
                  <option value="">Selecione...</option>
                  <option :value="c.id" v-for="(c, index) in cursos">{{ c.nome }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('curso')">{{ errors.first('curso') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('turma')}">
                <checkbox v-model="filtros.porTurma" :true-value="true" type="success">Turma</checkbox>

                <select disabled
                        id="turma"
                        class="form-control"
                        v-model="filtros.idTurma"
                        data-vv-name="turma"
                        v-validate="filtros.porTurma ? 'required' : ''">
                  <option value="">Selecione...</option>
                  <option :value="t.id" v-for="(t, index) in turmas">{{ t.nome }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('turma')">{{ errors.first('turma') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('situacao')}">
                <checkbox v-model="filtros.porSituacao" :true-value="true" type="success">Situação</checkbox>

                <select disabled
                        id="situacao"
                        class="form-control"
                        v-model="filtros.idSituacao"
                        data-vv-name="situacao"
                        v-validate="filtros.porSituacao ? 'required' : ''">
                  <option value="">Selecione...</option>
                  <option value="1">Pagas</option>
                  <option value="2">Em aberto</option>
                </select>

                <p class="text-danger" v-show="errors.has('situacao')">{{ errors.first('situacao') }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="Object.keys(relatorio).length !== 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Mensalidades Agrupadas por Aluno" borda=""></cabecalho-relatorio>

    <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatoriobody">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table table-condensed no-margins">
                <thead>
                  <tr>
                    <th v-if="porAluno">Aluno</th>
                    <th v-if="porVencimento">Período de vencimento</th>
                    <th v-if="porPagamento">Período de pagamento</th>
                    <th v-if="porCurso">Curso</th>
                    <th v-if="porTurma">Turma</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="porAluno">{{ aluno.nome }}</td>
                    <td v-if="porVencimento">{{ `${dataVencimentoInicio} - ${dataVencimentoFim}` }}</td>
                    <td v-if="porPagamento">{{ `${dataPagamentoInicio} - ${dataPagamentoFim}` }}</td>
                    <td v-if="porCurso">{{ curso.nome }}</td>
                    <td v-if="porTurma">{{ turma.nome }}</td>
                  </tr>
                </tbody>
              </table>
              
              <table class="table relatorio table-bordered">
                <tbody>
                  <template v-for="aluno in relatorio">
                    <tr>
                      <td class="bg-muted font-bold" colspan="5">Aluno: {{ aluno[0].nomePessoa }}</td>
                      <td class="bg-muted font-bold" colspan="4">CPF: {{ aluno[0].cpf }}</td>
                      <td class="bg-muted font-bold" colspan="2">Cod. Aluno: {{ aluno[0].idPessoa }}</td>
                    </tr>
                    <tr>
                      <td class="bg-muted font-bold" colspan="5">Curso: {{ aluno[0].descricaoCurso }}</td>
                      <td class="bg-muted font-bold" colspan="4">Turma: {{ aluno[0].nomeTurma }}</td>
                      <td class="bg-muted font-bold" colspan="2">Matrícula: {{ aluno[0].numeroMatricula }}</td>
                    </tr>
                    <tr>
                      <td class="font-bold">Vencimento</td>
                      <td class="font-bold">Data pagamento</td>
                      <td class="font-bold">Atraso (dias)</td>
                      <td class="font-bold">Parcela</td>
                      <td class="font-bold">Código</td>
                      <td class="text-right font-bold">Valor parcela</td>
                      <td class="text-right font-bold">Bolsa</td>
                      <td class="text-right font-bold">Valor a receber</td>
                      <td class="text-right font-bold">Acréscimo</td>
                      <td class="text-right font-bold">Descontos</td>
                      <td class="text-right font-bold">Valor pago</td>
                    </tr>
                    <tr v-for="parcela in aluno">
                      <td>{{ parcela.dataVencimento | formatarData }}</td>
                      <td>{{ parcela.data | formatarData(parcela.cancelada ? 'Cancelada' : '---') }}</td>
                      <td>---</td>
                      <td>{{ parcela.documentoReceberPagar || '---' }}</td>
                      <td>{{ parcela.idLancamento }}</td>
                      <td class="text-right">{{ (parcela.valorReceberPagar + parcela.descontoMensalidade) | formatarNumero }}</td>
                      <td class="text-right">{{ parcela.descontoMensalidade | formatarNumero }}</td>
                      <td class="text-right">{{ parcela.valorReceberPagar | formatarNumero }}</td>
                      <td class="text-right">{{ (parcela.juros + parcela.multa) | formatarNumero }}</td>
                      <td class="text-right">{{ parcela.desconto | formatarNumero }}</td>
                      <td class="text-right">{{ parcela.valorPago | formatarNumero }}</td>
                    </tr>
                    <tr>
                      <td class="font-bold" colspan="5">Total aluno: {{ aluno[0].nomePessoa }}</td>
                      <td class="text-right font-bold">{{ totalValorParcelaPorAluno(aluno) | formatarNumero }}</td>
                      <td class="text-right font-bold">{{ totalBolsaPorAluno(aluno) | formatarNumero }}</td>
                      <td class="text-right font-bold">{{ totalValorReceberPorAluno(aluno) | formatarNumero }}</td>
                      <td class="text-right font-bold">{{ totalAcrescimoPorAluno(aluno) | formatarNumero }}</td>
                      <td class="text-right font-bold">{{ totalDescontoPorAluno(aluno) | formatarNumero }}</td>
                      <td class="text-right font-bold">{{ totalValorPagoPorAluno(aluno) | formatarNumero }}</td>
                    </tr>
                    <tr>
                      <td colspan="11">&nbsp;</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/MensalidadesAgrupadasPorAluno.vue